import { Link } from 'react-router-dom';
import { Button, Paper, Typography } from '@safedns/skydns-ui-react-lib';
import './Collections.scss';

import img from '../../icons/no-collections.svg';

const CollectionsEmptyCreate = () => {
  return (
    <Paper>
      <div className="collections-empty-container">
        <div className="collections-empty-info">
          <Typography className="collections-empty-text">
            Коллекция — это способ группировки <br /> пользователей в Active
            Directory. Создайте <br /> свою первую коллекцию и выберите для{' '}
            <br />
            нее политику фильтрации.
          </Typography>
          <Link to="/" className="collections-empty-link">
            Инструкция Active Directory
          </Link>
          <div style={{ paddingTop: '32px' }} />
          <Button
            variant="primary"
            href="/collections/create"
          >
            Создать
          </Button>
        </div>
        <div className="collections-empty-image-container">
          <img
            src={img}
            width="100%"
            height="auto"
            alt="no collections yet"
          />
        </div>
      </div>
    </Paper>
  );
};

export default CollectionsEmptyCreate;
